<template>
  <div>
    <div v-if="$mq.lg" class="flex justify-end px-8">
      <div
        @click="dropdownToggle = !dropdownToggle"
        class="z-50 cursor-pointer flex items-center"
      >
        <div class="mr-6 relative w-32 h-32">
          <i
            class="far fa-user-circle absolute bottom-0 center-x lg:text-4xl"
          ></i>
        </div>
        <!-- <i v-if="dropdownToggle" class="fas fa-angle-up text-xl"></i>
        <i v-else class="fas fa-angle-down text-xl"></i> -->
      </div>

      <div
        v-if="dropdownToggle"
        class="absolute bg-white sign-out-panel mt-18 shadow-lg z-20 px-16 pt-10 fit-content rounded-md"
      >
        <p class="no-wrap py-16 border-b border-gray text-center mb-10">
          Hi, {{ firstname }}!
        </p>
        <a href="/sign-out" class="block pt-10 pb-20 w-full">
          <i class="fas fa-arrow-from-left mr-8"></i> Sign Out
        </a>
      </div>
    </div>

    <div v-else>
      <a
        href="/sign-out"
        class="block w-full text-center py-12 bg-orange text-white rounded-lg"
      >
        Logout
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserButton",

  props: {
    firstname: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dropdownToggle: false,
    };
  },
};
</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}

.sign-out-panel {
  margin-top: 48px;
  border: 1px #cacaca solid;
}
</style>
